import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  container: {
    "& > :last-child > :last-child > :first-child": {
      fontSize: "24px !important",
      marginTop: 15,
    },
  },
});
